// extracted by mini-css-extract-plugin
module.exports = {"main":"Form_main__mmCkV","content":"Form_content__81BDN","form":"Form_form__p1fxc","selectContainer":"Form_selectContainer__VqSe6","btn":"Form_btn__ffM1b"};